
/**
* Accumulated筛选器默认值
*/
export const ACCUMULATED_VALUE = 'date';
export const ACCUMULATED_TEXT = 'By Date';



